export default "__VITE_ASSET__bX9WZfJz__"